import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Page from '@src/components/page';
import xauCss from '@src/components/xfe-animation-css';
import Button from '@src/components/button';
import Link from '@src/components/link';
import $$tracker from '@src/tracker';
import Store from './store';
import BacktopFooter from '@src/business-components/backtop-footer';

const styles = require('./index.less');

const Download = ({ store }) => {
  const { layerData = {} } = store;
  const { download = {} } = layerData;
  store.use();

  React.useEffect(() => {
    $$tracker.loadDownloadPage();
  }, []);

  return (
    <Page className={cx(styles.root, store.isActive && xauCss.AOS_ROOT)}>
      <Button className={styles.btnBack} onClick={store.back} />
      <div className={cx(styles.title, styles.bigTitle, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })} />
      <section ref={store.scrollBox} className={styles.wrapper}>
        {/* 下载方式 */}
        <section className={cx(styles.downloadMethod, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(3) })}>
          <Link
            style={{ backgroundImage: `url(${require('./images/btn-download.png')})` }}
            className={styles.btnDownload}
            href={download.launcher_download_link}
            onClick={() => $$tracker.clickQdq()}
          />
        </section>
        <div className={cx(styles.divider, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })} />
        {/* 安装常见问题 */}
        <section className={styles.installerQuestion}>
          <div
            style={{ backgroundImage: `url(${require('./images/title-installer-question.png')})` }}
            className={cx(styles.subTitle, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })}
          />
          <div className={cx(styles.content, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(3) })}>
            {store.installerQuestion.map((item, index) => (
              <Link key={index} className={styles.link} href={item.link} target="_blank">
                {item.title}
              </Link>
            ))}
          </div>
        </section>
        {/* 推荐配置 */}
        <section className={styles.recommConfig}>
          <div
            style={{ backgroundImage: `url(${require('./images/title-recom-config.png')})` }}
            className={cx(styles.subTitle, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })}
          />
          <div className={cx(styles.content, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(3) })}>
            <div className={styles.configTable} />
          </div>
        </section>
        {/* 显示驱动程序下载 */}
        <section className={styles.graphicsCardInstaller}>
          <div
            style={{ backgroundImage: `url(${require('./images/title-graphics-card-installer.png')})` }}
            className={cx(styles.subTitle, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })}
          />
          <div className={cx(styles.content, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(3) })}>
            {store.graphicsCardInstallerPackage.map((item, index) => (
              <div className={styles.installerPackage}>
                <img src={item.icon} className={styles.icon} alt={item.title} />
                <Link key={index} className={styles.link} href={item.link} target="_blank">
                  点击下载
                </Link>
              </div>
            ))}
          </div>
        </section>
      </section>
      <BacktopFooter position="fixed" onBackTop={store.onBackTop} showBtnBackTop={store.isShowBackTop} />
    </Page>
  );
};

export default wrapStore(Download, Store);
